import { render, staticRenderFns } from "./StudentSignInManage.vue?vue&type=template&id=52676abe&scoped=true"
import script from "./StudentSignInManage.vue?vue&type=script&lang=js"
export * from "./StudentSignInManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52676abe",
  null
  
)

export default component.exports